export type TSimulationProgressModalProps = {
  className?: string;
  style?: React.CSSProperties;
};

export enum EGraphFilterType {
  price = 'Price',
  volume = 'Volume',
}
